function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "User");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M16 17.293H0v-2.18c-.003-1.268.76-2.408 1.919-2.863a17.342 17.342 0 0112.15.014c1.164.451 1.933 1.594 1.931 2.867v2.162zM4 4.09C4 1.833 5.79 0 8 0s4 1.832 4 4.09c0 2.311-1.791 5.021-4 5.021s-4-2.71-4-5.02z"
}));

var SvgUserSilhouette = function SvgUserSilhouette(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 16 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUserSilhouette, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-silhouette.2618f5f3.svg";
export { ForwardRef as ReactComponent };